"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EncounterDetailSchema () {
        return EncounterDetailSchema;
    },
    get EncounterSoapSchema () {
        return EncounterSoapSchema;
    },
    get EncounterUserRefSchema () {
        return EncounterUserRefSchema;
    },
    get EncounterVitalsSchema () {
        return EncounterVitalsSchema;
    }
});
const _zod = require("zod");
const _encounterstatus = require("./encounter-status");
const _icd10search = require("../icd10/icd10-search");
const isoDateTime = ()=>_zod.z.string().datetime({
        offset: true
    });
const EncounterUserRefSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    displayName: _zod.z.string().nullable()
}).strict();
const EncounterVitalsSchema = _zod.z.object({
    bpSystolic: _zod.z.number().int().nullable(),
    bpDiastolic: _zod.z.number().int().nullable(),
    heartRate: _zod.z.number().int().nullable(),
    respiratoryRate: _zod.z.number().int().nullable(),
    temperatureC: _zod.z.number().nullable(),
    weightKg: _zod.z.number().nullable(),
    heightCm: _zod.z.number().nullable(),
    bmi: _zod.z.number().nullable(),
    version: _zod.z.number().int().min(1),
    recordedAt: isoDateTime(),
    recordedBy: EncounterUserRefSchema
}).strict();
const EncounterSoapSchema = _zod.z.object({
    chiefComplaint: _zod.z.string().nullable(),
    subjective: _zod.z.string().nullable(),
    objective: _zod.z.string().nullable(),
    plan: _zod.z.string().nullable(),
    version: _zod.z.number().int().min(0),
    updatedAt: isoDateTime()
}).strict();
const EncounterDetailSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    encounterNo: _zod.z.string().regex(/^ENC-\d{6,}$/, {
        message: 'Invalid encounter number.'
    }),
    patientId: _zod.z.string().uuid(),
    provider: EncounterUserRefSchema,
    status: _encounterstatus.EncounterStatusSchema,
    startedAt: isoDateTime(),
    signedAt: isoDateTime().nullable(),
    signedBy: EncounterUserRefSchema.nullable(),
    vitals: EncounterVitalsSchema.nullable(),
    soap: EncounterSoapSchema,
    diagnoses: _zod.z.array(_icd10search.Icd10SearchItemSchema)
}).strict().superRefine((encounter, ctx)=>{
    const isSigned = encounter.status === 'signed';
    if (isSigned !== (encounter.signedAt !== null)) {
        ctx.addIssue({
            code: 'custom',
            path: [
                'signedAt'
            ],
            message: 'signedAt must be set if and only if status is signed.'
        });
    }
    if (isSigned !== (encounter.signedBy !== null)) {
        ctx.addIssue({
            code: 'custom',
            path: [
                'signedBy'
            ],
            message: 'signedBy must be set if and only if status is signed.'
        });
    }
});
